export default "__VITE_ASSET__BfdmmWnu__"